import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export { default as Button } from "./Button.vue";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        // An outline until hover, so a Delete beside other actions reads as
        // one of them rather than as the page's loudest control.
        destructive:
          "border border-destructive bg-background text-danger hover:bg-destructive hover:text-destructive-foreground focus-visible:ring-destructive/40",
        // The user portal's logout, and nothing else: solid, because on that
        // page ending the session is the one way out and should be easy to find.
        logout:
          "border border-destructive bg-destructive text-destructive-foreground hover:bg-destructive/85 focus-visible:ring-destructive/40",
        outline:
          "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-border/30 dark:border-border dark:hover:bg-border/50",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        // Draws nothing until hover: only for an icon or beside the button it partners.
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        // No `link` variant: a link is a real link, never a button.
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        xs: "h-6 gap-1 rounded-md px-2 text-xs has-[>svg]:px-1.5 [&_svg:not([class*='size-'])]:size-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-4 py-2",
        icon: "size-9",
        "icon-xs": "size-6 rounded-md [&_svg:not([class*='size-'])]:size-3",
        "icon-sm": "size-8",
        "icon-lg": "size-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
export type ButtonVariants = VariantProps<typeof buttonVariants>;
